import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {Input, Button} from 'reactstrap';
import heroImage from './ew_slide.jpg';




class LandingPage extends Component {

    state={}
    componentDidMount() {
        // const token = localStorage.getItem('token');
        // if (token != null && token.length > 0) {
        //     this.setState({redirect: '/dashboard'});
        // }
    }

   RedSection = {
        background: "linear-gradient(270deg, #FCB614 0%, #F8B51B 61.27%, #F8B51B 79.5%, #F7B51D 100%)"
    }

    redFont = {
        color: "#FAB616"
    }

    buttonColor={
        color:"white",
        background:"#FAB616"
    }

    partnerLogo = {
        maxWidth: "180px"
    }

    FeatureIcon = {
        borderRadius: "50%",
        fontSize: "1.25rem",
        backgroundColor: "#FAB616",
        color: "white",
        width: "2.5em",
        height: "2.5em",
        lineHeight: "1.5",
        padding: "0.45em"
    }

    IntroText = {
        fontSize: "18px",
        lineHeight: "2em"
    }

    IntroHeader = {
        fontSize: "36px",
        lineHeight: "1.2em",
        color: "#FAB616",
        fontWeight: "700"
    }

    ParaText = {
        fontSize: "16px",
        marginBottom: "30px",
        lineHeight: "2em"
    }

    FrontButton = {
        fontSize: "16px",
        minWidth: "270px",
        padding: "12px"
    }

    NavLink = {
        fontSize: "16px",
    }

    ContactList = {
        fontSize: "15px",
        lineHeight: "1.8em"  
    }

    HeroHeader = {
        backgroundImage: `linear-gradient(to top, rgba(35, 85, 40, 0.45), rgba(40, 43, 58, 0.25)), url(${heroImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: "600px"
    }

    HeroText = {
        width: "100%",
        textAlign: "center",
        marginTop: "150px",
        marginBottom: "140px"
    }

    HeroSubText = {
        fontSize: "20px",
        marginBottom: "40px",
        marginTop: "20px",
        fontWeight: "500"
    }

    ViewLogin = () => {
        return this.props.history.push('/login')
    }

    ViewSignUp = () => {
        return this.props.history.push('/register')
    }

   

    onSubmit = e => {
        e.preventDefault();
        this.ViewLogin();
    }

    render() {
        const year = new Date().getFullYear()
        return (
            <div className="bg-white">
               <header>
                    { /* START Top Navbar */}
                    <nav className="navbar topnavbar  px-5">
                        { /* START navbar header */}
                        <div className="navbar-header">
                            <a className="navbar-brand" href="#/">
                                <div className="brand-logo">
                                    <img className="img-fluid" src="img/web.png" alt="App Logo" />
                                </div>
                                <div className="brand-logo-collapsed">
                                    <img className="img-fluid" src="img/web.png" alt="App Logo" />
                                </div>
                            </a>
                        </div>
                        { /* END navbar header */}

                        <div className="navbar-nav flex-row">
                            <ul className="nav mx-3 px-3">
                                <li className="nav-item mx-3">
                                    <a class="nav-link text-white" href="#about" style={this.NavLink}>About</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a class="nav-link text-white" href="#features" style={this.NavLink}>Features</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a class="nav-link text-white" href="#partners" style={this.NavLink}>Partners</a>
                                </li>
                                <li className="nav-item mx-3">
                                    <a class="nav-link text-white" href="#contact" style={this.NavLink}>Contact Us</a>
                                </li>
                            </ul>
                            <Button outline onClick={this.ViewLogin} color="success" className="btn-pill mr-3">Login</Button>
                            <Button outline color="success" onClick={this.ViewSignUp} className="btn-pill mr-3">Sign Up</Button>
                        </div>
                    </nav>
                </header>

                <div className="container-fluid px-0">
                    <div style={this.HeroHeader} className="py-5">
                        <div style={this.HeroText} className="px-md-5 px-3">
                            <h1 className="text-white mb-3">The best bulk SMS gateway in Tanzania</h1>
                            <p style={this.HeroSubText} className="text-white">Say Hello to your customers<br/>
                            with personalized sms compaigns delivered in a timely fashion.<br/>
                            </p>                           
                        </div>
                    </div>
                </div>

                <div className="container py-3 my-lg-5 my-4">
                    <div className="row my-4" id="about">
                        <div className="col-lg-4">
                            <h2 className="text-center my-md-4 my-2" style={this.IntroHeader}><strong>About WebSMS <br/> Portal</strong></h2>
                        </div>   
                        <div className="col-lg-8">
                            <p style={this.IntroText}> WebSMS is a mordern bulk sms gateway built with mordern technologies to deliver a bulk volume of sms to your customers.
                            The gateway support both instant and scheduled campaigns for bussiness to reach to their customers through SMS while being affordable.
                            Customizable Sender IDs , API intergration , Multi User Support and simplicity in mind makes us the best choice to deliver SMS to your customers.
                            </p>
                        </div>
                    </div>
                </div>
            
                <div className="container-fluid text-dark px-0 mt-5">
                    <h2 className="text-center my-md-4 my-2" id="features"><strong>WebSMS Features</strong></h2>
                    <div className="row no-gutters m-lg-5 m-3">
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fas fa-mobile-alt mb-3" style={this.FeatureIcon}></span>
                            <h4>Low-cost solution</h4>
                            {/* <p style={this.ParaText}>The platform employs the use of USSD service and mobile application to ensure affordability and mobility.</p> */}
                            <p style={this.ParaText}>The platform offers the most competitive prices in the market and delivers SMS to all MNO's in Tanzania.</p>
                        </div>
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fa fa-sync-alt mb-3" style={this.FeatureIcon}></span>
                            <h4>Instant Delivery</h4>
                            <p style={this.ParaText}>All SMS sent are delivered instantly to your customer adding value to your bussiness.</p>
                        </div>
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fa fa-id-badge  mb-3" style={this.FeatureIcon}></span>
                            <h4>Customizable Sender ID's</h4>
                            <p style={this.ParaText}>Deliver SMS to your customers with company branded Sender Id's adding trust to your message.</p>
                        </div>
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fa fa-chart-line mb-3" style={this.FeatureIcon}></span>
                            <h4>Elegant analytics and reports</h4>
                            <p style={this.ParaText}>WebSMS portal assists in decision making since it catalogs, analyzes and give reports relevant to your bussiness.</p>
                        </div>
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fa fa-users mb-3" style={this.FeatureIcon}></span>
                            <h4>Multi-User Platform</h4>
                            <p style={this.ParaText}>The multiple users feature allows different types of users to efficiently access the platform with different  privileges.</p>
                        </div>
                        <div className="col-sm-6 col-lg-4 text-center px-md-4 px-2 py-3">
                            <span className="fa fa-link mb-3" style={this.FeatureIcon}></span>
                            <h4>API Integration</h4>
                            <p style={this.ParaText}>Restful API providing an interface to interact with your existing systems building a powerful ecosystem.</p>
                        </div>
                    </div>
                </div>

                <div className="text-center container-fluid py-5 px-lg-5" style={this.RedSection} id="partners">
                    <h1 className="text-white my-3"><strong>Our Partner Networks</strong></h1>
                    <div className="row py-lg-4 py-2 justify-content-center my-2">
                    <div className="col-lg-2 col-md-1 ">
                            <img className="img-fluid" style={this.partnerLogo} src="img/vodacom.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Vodacom Tanzania</em></h4> */}
                        </div>
                        <div className="col-lg-2 col-md-1">
                            <img className="img-fluid" style={this.partnerLogo} src="img/airtel.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Airtel Tanzania</em></h4> */}
                        </div>
                        <div className="col-lg-2 col-md-1">
                            <img className="img-fluid" style={this.partnerLogo} src="img/tigo.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Tigo </em></h4> */}
                        </div>
                        <div className="col-lg-2 col-md-1">
                            <img className="img-fluid" style={this.partnerLogo} src="img/ttcl.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Ttcl</em></h4> */}
                        </div>
                        <div className="col-lg-2 col-md-1">
                            <img className="img-fluid" style={this.partnerLogo} src="img/halotel.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Halotel</em></h4> */}
                        </div>
                        <div className="col-lg-2 col-md-1">
                            <img className="img-fluid" style={this.partnerLogo} src="img/zantel.png" alt="Vodacom Logo" />
                            {/* <h4 className="text-white mt-lg-3 mt-2"><em>Zantel</em></h4> */}
                        </div>
                      
                    </div>
                </div>

                <div className="container-fluid text-dark px-0">
                    <div className="text-center my-md-5 my-3" id="contact">
                        <h1 className="mb-4 pt-2">For More Information</h1>
                        <h4 className="px-2">Contact us to find out more about WebSMS portal.</h4>
                    </div>
                    <hr className="my-md-4 my-2"/>
                    <div className="row px-md-4 px-2 mx-md-4 pt-2 pb-4 mb-3 no-gutters">
                        <div className="col-md-4 px-md-3 px-2 py-md-3 py-2 ml-md-3">
                            <h4><span className="fa fa-home" style={this.redFont}></span> &nbsp;HEAD OFFICE ADDRESS :</h4>
                            <ul className="list-unstyled ml-2" style={this.ContactList}>
                                <li>Web Corporation Tanzania,</li>
                                <li>Al Falah (KFC) Building, 4th Floor</li>
                                <li>Livingstone/Msimbazi Street ,</li>
                                <li>P.O. Box 70307,</li>
                                <li>Dar es Salaam, Tanzania.</li>
                            </ul>
                            <h4 className="mt-md-4 mt-3"><span className="fa fa-phone-alt" style={this.redFont}></span> &nbsp; TELEPHONE :</h4>
                            <ul style={this.ContactList}>
                                <li>+255 222 182 912</li>
                                <li>+255 759 888 333</li>
                                <li>+255 716 888 333</li>
                                <li>+255 685 888 333</li>
                            </ul>
                            <h4 className="mt-md-4 mt-3"><span className="fa fa-envelope" style={this.redFont}></span> &nbsp; BUSSINESS EMAIL :</h4>
                            <ul style={this.ContactList}>
                                <li>info@webcorporation.co.tz</li>
                            </ul>
                        </div>
                        <div className="col-md-7 px-md-3">
                            <div className="bg-light p-md-4 p-2">
                                <form className="mb-3 p-md-2 p-1"  name="formContact" onSubmit={this.onSubmit}>
                                    <div className="form-group px-2">
                                        <label>Full name</label>
                                        <div className="input-group with-focus">
                                            <Input type="text" name="name"
                                                className="border-right-0 form-control form-control-lg rounded-0"
                                                placeholder="Enter full name" />
                                            <div className="input-group-append">
                                                <span className="input-group-text bg-transparent border-left-0">
                                                    <em className="fa fa-user"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>  
                                    <div className="form-group px-2">
                                        <label>Phone number</label>
                                        <div className="input-group with-focus">
                                            <Input type="tel" name="phone"
                                                className="border-right-0 form-control form-control-lg rounded-0"
                                                placeholder="Enter phone number" />
                                            <div className="input-group-append">
                                                <span className="input-group-text bg-transparent border-left-0">
                                                    <em className="fa fa-phone-alt"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group px-2">
                                        <label>Email address</label>
                                        <div className="input-group with-focus">
                                            <Input type="email" name="email"
                                                className="border-right-0 form-control form-control-lg rounded-0"
                                                placeholder="Enter email address" />
                                            <div className="input-group-append">
                                                <span className="input-group-text bg-transparent border-left-0">
                                                    <em className="fa fa-envelope"></em>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group px-2">
                                        <label>Message</label>
                                        <Input type="textarea" name="message"
                                            className="form-control rounded-0"
                                            rows = "4"
                                            placeholder="Message" />
                                    </div>
                                    <div className="px-2">
                                        <button className="btn  mt-3" type="submit" style={this.buttonColor}>Submit Message</button>
                                    </div>                           
                                </form>
                            </div>
                        </div>
                    </div>
                    
                    <div className="block-center">
                        <div className="p-3 text-center">
                            &copy;&nbsp;{year}&nbsp;-&nbsp;WEB CORPORATION
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default LandingPage;
